import $ from "jquery";
import swal from "sweetalert";
$(document).ready(function () {
    $('body').on("click", ".delete-item", function (e) {
        e.preventDefault();
        var url = $(e.currentTarget).attr("href");
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this item!",
            icon: "warning",
            buttons: ["Cancel", "Confirm"],
            dangerMode: true
        })
            .then(function (willDelete) {
            if (willDelete) {
                $.post(url, function () {
                    document.location.reload();
                    // swal({
                    //     title: "Success",
                    //     text: "The item has been deleted!",
                    //     icon: "success",
                    //     dangerMode: true,
                    // }).then(() => {
                    // });
                });
            }
            else {
            }
        });
    });
    $('body').on("click", ".copy-item", function (e) {
        e.preventDefault();
        var url = $(e.currentTarget).attr("href");
        swal({
            title: $(e.currentTarget).attr("data-s-title"),
            text: $(e.currentTarget).attr("data-s-message"),
            icon: "warning",
            buttons: [$(e.currentTarget).attr("data-s-cancel"), $(e.currentTarget).attr("data-s-confirm")],
            dangerMode: true
        })
            .then(function (willDelete) {
            if (willDelete) {
                window.location.href = url;
                // $.post(url, () => {
                //     swal({
                //         title: "Success",
                //         text: "The item has been deleted!",
                //         icon: "success",
                //         dangerMode: true,
                //     }).then(() => {
                //         document.location.reload();
                //     });
                // })
            }
            else {
            }
        });
    });
    $('body').on("click", ".need-confirmation", function (e) {
        e.preventDefault();
        var url = $(e.currentTarget).attr("href");
        swal({
            title: $(e.currentTarget).data("title"),
            text: $(e.currentTarget).data("message"),
            icon: "warning",
            buttons: [$(e.currentTarget).data("cancel"), $(e.currentTarget).data("confirm")],
            dangerMode: true
        })
            .then(function (willDelete) {
            if (willDelete) {
                $.post(url, function () {
                    swal({
                        title: "",
                        text: $(e.currentTarget).data("success"),
                        icon: "success",
                        dangerMode: true
                    }).then(function () {
                        document.location.reload();
                    });
                });
            }
            else {
            }
        });
    });
});
